import store from "../store";
import { getNormalizeDate } from "./getNormalizeDate";
import moment from "moment";
import { calcDays } from "./calcDays";

export const getProtocoInfo = async () => {

  await store.commit("setWinnerInfo", null);
  if (store.getters.protocol_info === null) {
    const purchase_number = String(store.getters.calc.purchase_number)
      .trim()
      .replace(/\s|\s+/, "");

    if (purchase_number !== "" && purchase_number !== null && purchase_number !== 'null') {
      const infoObj = {
        purchase_number,
        lot: 1
      };

      if (!purchase_number) return;

      const item = await store.dispatch("PROTOCOL_INFO_BY_NUMBER", infoObj);



      await store.dispatch("SET_CALC_PARAM", {
        param: "lot",
        value: 1
      });
      await store.dispatch("SET_CALC_PARAM", {
        param: "dogovor_subject",
        value: item.name
      });
      // await store.dispatch("SET_CALC_PARAM", {
      //   param: "quaranteesVal",
      //   value: 1
      // });
      await store.dispatch("SET_CALC_PARAM", {
        param: "summ",
        value: item.guarantee ? item.guarantee : item.guaranteeing
      });
      if (item.fz !== null) {
        switch (item.fz) {
          case 44:
            await store.dispatch("SET_CALC_PARAM", {
              param: "purchasesVal",
              value: 1
            });
            break;
          case 223:
            await store.dispatch("SET_CALC_PARAM", {
              param: "purchasesVal",
              value: 2
            });
            break;
          case 615:
            await store.dispatch("SET_CALC_PARAM", {
              param: "purchasesVal",
              value: 3
            });
            break;
          default:
            await store.dispatch("SET_CALC_PARAM", {
              param: "purchasesVal",
              value: 4
            });
            break;
        }
      }else{
        await store.dispatch("SET_CALC_PARAM", {
          param: "purchasesVal",
          value: 1
        });
      }

      if (item.purchase) {
        if (item.purchase.customer) {
          item.purchase.customer.shortName &&
            (await store.dispatch("SET_CALC_PARAM", {
              param: "customer",
              value: item.purchase.customer.shortName
            }));

          item.purchase.customer.inn &&
            (await store.dispatch("SET_CALC_PARAM", {
              param: "customer_inn",
              value: item.purchase.customer.inn
            }));
        }

      }

      const date2 =
        item.purchase && item.purchase.deliveryDate
          ? getNormalizeDate(item.purchase.deliveryDate, "en")
          : item.contractTerm && item.contractTerm.date
          ? getNormalizeDate(item.contractTerm.date, "en")
          : null;


      date2 &&
        (await store.dispatch("SET_CALC_PARAM", {
          param: "date2",
          value: moment(date2)
            .add(31, "days")
            .format("DD.MM.YYYY")
        }));
      date2 &&
        (await store.dispatch("SET_CALC_PARAM", {
          param: "msgDate",
          value: true
        }));
      const dd1 = store.getters.calc.date;
      const dd2 = store.getters.calc.date2;

      dd1 &&
        dd2 &&
        (await store.dispatch("SET_CALC_PARAM", {
          param: "days",
          value: await calcDays(dd1, dd2)
        }));

      await store.dispatch("SET_CALC_PARAM", {
        param: "client_inn",
        value: item.winner_inn
      });
      await store.dispatch("SET_CALC_PARAM", {
        param: "client_name",
        value: item.winner_name
      });
      if (item.winner_inn) {
        store
          .dispatch("SEND_INN_TO_CHECK", {
            val: item.winner_inn,
            err: err => {
              // const reg = /Request failed with status code 500/;
              // if (reg.test(err)) {
              //   Swal.fire({
              //     icon: "info",
              //     title: "Уведомление",
              //     text: "Данные по победителю не получены",
              //   });
              // }
              // this.wins = [];
            }
          })
          .then(async res => {
            await store.commit("setWinnerInfo", res.data);
            const winnerInfo = { ...store.getters.getWinnerInfo };

            if (winnerInfo) {
              if (
                winnerInfo.main &&
                winnerInfo.main.data &&
                winnerInfo.main.data.name &&
                winnerInfo.main.data.name.short_with_opf
              ) {
                const ProtocolInfo = { ...store.getters.protocol_info };
                store.commit("setProtocolInfo", ProtocolInfo);
                ProtocolInfo.winner_name =
                  winnerInfo.main.data.name.short_with_opf;
                await store.dispatch("SET_CALC_PARAM", {
                  param: "client_name",
                  value: winnerInfo.main.data.name.short_with_opf
                });
              } else {
                winnerInfo &&
                  winnerInfo.main &&
                  winnerInfo.main.value &&
                  (await store.dispatch("SET_CALC_PARAM", {
                    param: "client_name",
                    value: winnerInfo.main.value
                  }));
              }
              Object.assign([], winnerInfo.wins)
                .sort((a, b) => (Number(a.year) < Number(b.year) ? 1 : -1))
                .slice(0, 3);
            }
          });
      } else {
        item.winner_name = "N/A";
      }

      store.commit("setProtocolInfoShowed", true);
    }
  }
};
